import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  flex-wrap: wrap;
  position: relative;
  top: -160px;
  z-index: 3;

  @media (max-width: 650px) {
    flex-direction: column;
    align-items: center;
    top: -100px;
  }

  @media (max-width: 470px) {
    flex-direction: column;
    align-items: center;
    top: -70px;
  }

  @media (max-width: 1224px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CardIcon = styled(FontAwesomeIcon)`
  color: #3393f0;
  transition: color 0.2s ease-in-out;
  min-width: 50px;
`;

export const CardTitle = styled.h3`
  margin-bottom: 15px;
  color: rgb(33, 100, 167);
  transition: color 0.2s ease-in-out;
`;

export const Card = styled.div`
  background-color: white;
  line-height: 1.3;
  font-size: 14px;
  padding: 30px;
  gap: 15px;
  border-radius: 10px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
  width: 32%;
  transition: background-color 0.8s ease-in-out;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #3393f0;

    ${CardIcon} {
      color: white;
    }

    ${CardTitle} {
      color: white;
    }

    p {
      color: white;
    }
  }

  @media (max-width: 1224px) {
    width: 90%;
  }
`;

export const CardContact = styled.a`
  background-color: white;
  text-decoration: none;
  padding: 30px;
  gap: 15px;
  border-radius: 10px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
  width: 32%;
  transition: background-color 0.8s ease-in-out;
  display: flex;
  align-items: center;
  background-color: #3393f0;

  &:hover {
    background-color: #3393f0;

    ${CardIcon} {
      color: white;
    }
  }

  @media (max-width: 1224px) {
    width: 90%;
  }
`;

export const AboutCardContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  max-width: 1100px;
  margin: 20px auto;
  position: relative;
  top: -175px;
  z-index: 4;
  border-radius: 12px;

  @media (max-width: 470px) {
    top: -85px !important;
  }

  @media (max-width: 649px) {
    top: -95px;
  }

  @media (max-width: 1224px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const AboutCardImage = styled.img`
  width: 60%;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  object-fit: cover;

  @media (max-width: 1224px) {
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.4);
    width: 81%;
  }
`;

export const AboutCardTextBox = styled.div`
  margin: 10px 0 0 0;

  @media (max-width: 1224px) {
    margin: 0 50px 0 30px;
    width: 83%;
  }
`;

export const AboutCardTextBoxTitle = styled.h1`
  margin-top: 5px;
  color: #17224d;
  margin-left: 20px;
`;

export const AboutCardTextBoxIntroTitle = styled.h2`
  font-size: 16px;
  color: rgb(33, 100, 167);
  margin-left: 20px;
  font-weight: lighter;
  letter-spacing: 2px;
`;

export const AboutCardTextBoxText = styled.p`
  margin-top: 20px;
  margin-left: 20px;
  line-height: 1.8;
  color: ${({ theme }) => theme.colors.darkblue};
`;
